import { queryClient as QueryClient } from '@lovoldsystem/core.client'

export const queryClient = QueryClient
